"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _text = require("@mmc/text");

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _infoHeader = require("./info-header.propTypes");

var _featureBlock = _interopRequireDefault(require("./feature-block"));

var _infoHeader2 = _interopRequireDefault(require("./info-header.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var publishDealerClickToDataLayer = function publishDealerClickToDataLayer(linkUrl, market) {
  if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
    if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dealer_locator_click',
        comp_page: {
          position: 'page'
        }
      });
    }
  }
};

var TextBlockCTA = function TextBlockCTA(_ref) {
  var data = _ref.data,
      theme = _ref.theme,
      config = _ref.config;
  var disclaimerData = data.disclaimerData;
  var market = config.market;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_infoHeader2["default"].textBlockContainer, theme['container-fluid'], theme['col-sm-10'], theme['col-md-7'], theme['col-lg-5'], theme.dark)
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: data.heading1,
    className: (0, _clsx["default"])(theme.headingOne, theme.marginBottom20),
    tag: "h1",
    automation: "textBlockHeading",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: data.textBlock,
    className: (0, _clsx["default"])(theme.introCopy, theme.marginBottom40),
    automation: "textBlockParagraph",
    tag: "p",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_infoHeader2["default"].featureBlock, theme.marginBottom40, theme.row)
  }, data.featureBlock && data.featureBlock.map(function (contact, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: contact.description || i,
      className: (0, _clsx["default"])(_infoHeader2["default"].featureBlockChild, theme['col-xs-12'], theme['col-sm'])
    }, /*#__PURE__*/_react["default"].createElement(_featureBlock["default"], {
      key: contact.description || i,
      theme: theme,
      data: contact
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _infoHeader2["default"].ctaWrapper
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      url: handleNestedProp(data, 'data.cta.URL'),
      label: handleNestedProp(data, 'data.cta.label'),
      openNewTab: handleNestedProp(data, 'data.cta.openNewTab'),
      priority: handleNestedProp(data, 'data.cta.priority'),
      ctaTheme: handleNestedProp(data, 'data.cta.ctaTheme'),
      icon: handleNestedProp(data, 'data.cta.icon')
    },
    mouseDownEvent: function mouseDownEvent() {
      return publishDealerClickToDataLayer(handleNestedProp(data, 'data.cta.URL'), market);
    }
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(TextBlockCTA));

exports["default"] = _default;